export default "__VITE_ASSET__4f4d146f__"